// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b56688b7","455":"436f4576","977":"426425bc"}[chunkId] + ".chunk.js";
};